import { colors } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        tourBlock: {
            width: 'calc(100% - 130px)',
            height: '100%',
            position: 'fixed',
            right: '0',
            top: '65px',
            background: '#00000096',
            zIndex: '1000',
            transitionDuration: '700ms',

            '&.openTour': {
                width: 'calc(100% - 370px)',
                transitionDuration: '700ms',
            }
        },
        tour: {
            width: '290px',
            boxShadow: '0px 32px 64px -12px #10182824',
            background: '#fff',
            position: 'fixed',
            zIndex: '100000',
            borderRadius: '8px',
            top: '126px',
            left: '389px',
            '&::after': {
                content: `" "`,
                position: 'absolute',
                left: '-10px',
                top: '25px',
                borderTop: '10px solid transparent',
                borderLeft: 'none',
                borderRight: '10px solid #fff',
                borderBottom: '10px solid transparent',
            }


        },
        tourBody: {
            padding: '0 15px',

            '& p': {
                fontSize: '12px',
                lineHeight: '20px',
                marginBottom: '15px',
                textAlign: 'justify',

            }


        },
        tourHeaer: {
            padding: '10px 15px',
            display: 'flex',
            justifyContent: 'space-between',
            '& h4': {
                color: '#2B398E'
            },


        },
        iconsClose: {
            background: 'var(--dig-gray-gb-100, #EEF0F2)',
            cursor: 'pointer',
            width: '18px',
            height: '18px',
            borderRadius: '50px',
            padding: '1px',

        },
        tourFooter: {
            padding: '10px 15px',

            display: 'flex',
            justifyContent: 'space-between',
            borderTop: '1px solid #e9e9e9',
            alignItems: 'center',


        },
        count: {
            color: '#9AA6B1',
            fontSize: '13px'

        },
        tourFooterButton: {
            '& .MuiButton-root': {
                height: '30px',
                borderRadius: '6px',
                marginRight: '9px',
                fontSize: '10px',
            }

        }

    };
});
